export default __webpack_public_path__ + "static/media/landingImage.e6e6a430.svg";